module.exports = __webpack_public_path__ + "img/Da.cc843333.png";